export enum FacilityType {
  College = 'College/University',
  ConventionCenter = 'Convention Center',
  Courthouse = 'Courthouse',
  DataCenter = 'Data Center',
  DrinkingWaterTreatment = 'Drinking Water Treatment & Distribution',
  FireStation = 'Fire Station',
  IndoorArena = 'Indoor Arena',
  Kto12 = 'K-12 School',
  Library = 'Library',
  MeetingHall = 'Social Meeting Hall',
  Museum = 'Museum',
  NonRefrigeratedWarehouse = 'Non-Refrigerated Warehouse',
  Office = 'Office',
  PerformingArts = 'Performing Arts',
  PoliceStation = 'Police Station',
  PostOffice = 'Mailing Center/Post Office',
  Prison = 'Prison/Incarceration',
  Recreation = 'Recreation',
  ResidenceHall = 'Residence Hall/Dormitory',
  ResidentialCare = 'Residential Care Facility',
  RetailStore = 'Retail Store',
  StadiumOpen = 'Stadium (Open)',
  SeniorLiving = 'Senior Living Community',
  SwimmingPool = 'Swimming Pool',
  TransportationTerminal = 'Transportation Terminal/Station',
  WastewaterTreatment = 'Wastewater Treatment Plant',
  Other = 'Other',
}
